<template>
      <b-row>

        <b-col cols="12" class="mt-1">
          <b-table 
              :tbody-tr-class="(item, r) => item && r === 'row' ? (item.groupRow ? 'group-row' : '') : null" 
              small 
              class="position-relative" 
              :items="data"
              responsive 
              :filter="filter"
              :fields="config.fields.map((field) => {
                field.label = $t(field.label)
                return field
              })"
              show-empty
              :empty-text='$t("No matching records found")' 
              @sort-changed="({sortBy, sortDesc})=> {
                if(sortBy === ''){
                  $emit('updateRequest', {key:'sortBy', value:'id,asc'})
                }else{
                  $emit('updateRequest', {key:'sortBy', value:(sortBy + ',' + (sortDesc ? 'desc' : 'asc'))})
                }
                $emit('getReport')
              }" 
              no-local-sorting
          >

            <template #cell(index)="data">
              {{ data.index + 1 }}
            </template>

            <template #cell(times)="data">
              <span v-b-tooltip.hover.right="$t(data.item.times)"> {{ $t(data.item.times) | str_limit(15) }}</span>
            </template>

            <template #cell(device_category)="data">
              {{ $t(data.item.device_category) }}
            </template>

            <template #cell(durations)="data">
              <span v-b-tooltip.hover.right="$t(data.item.durations)">{{ $t(data.item.durations) | str_limit(15) }}</span>
            </template>

            <template #cell(percent)="data">
              <span>
                {{ data.item.percent + "%" }}
              </span>
            </template>

            <template #cell(date)="data" style="color:red">

              <div v-if="Array.isArray(data.item.date)">
                <div v-if="data.item.day.includes('|')">
                  <span style="margin: 0.2rem" pill v-for="date in data.item.date.split('|')" v-bind:key="date.id">
                    {{ date }}
                  </span>
                </div>
              </div>

              <div v-if="data.item.date !== undefined && !data.item.date.includes('|')">
                {{ $t(data.item.date) }}
              </div>

            </template>

            <template #cell(day)="data" style="color:red">

              <div v-if="Array.isArray(data.item.day)">
                <div v-if="data.item.day.includes('|')">
                  <span style="margin: 0.2rem" pill v-for="day in data.item.day.split('|')" v-bind:key="day.id">
                    {{ $t(day) }}
                  </span>
                </div>
              </div>

              <div v-if="!data.item.day.includes('|')">

                {{ $t(data.item.day) }}
              </div>


            </template>

          </b-table>

        </b-col>
      </b-row>
</template>

<script>
import Ripple from 'vue-ripple-directive'
import { OrbitSpinner } from 'epic-spinners'
import {
  BTable, 
  BCard, 
  BCol,
  BRow, 
  VBTooltip,
} from 'bootstrap-vue'
export default {
  components: {
    BRow,
    BCard, 
    BTable,
    BCol,
    OrbitSpinner
  },
  directives: {
    Ripple, 'b-tooltip': VBTooltip,
  },
  emit:['updateRequest', 'getReport'],
  props: {
    data:{
      type: Array
    },
    config:{
      type:Object
    },
    request:{
      type:Object
    },
    filter:{
      type: String
    }
  }
}
</script>

<style lang="scss" scoped>
.group-row {
  background-color: #ddd;
}

.tooltip {
  font-size: 1.2rem;
}
</style>